__turbopack_context__.v({
  "description": "WReferenceLinkingToUrl-module__YQYuYW__description",
  "link": "WReferenceLinkingToUrl-module__YQYuYW__link",
  "title": "WReferenceLinkingToUrl-module__YQYuYW__title",
});
